import { render } from "./Search.vue?vue&type=template&id=4c526720&scoped=true"
import script from "./Search.vue?vue&type=script&async=true&lang=js"
export * from "./Search.vue?vue&type=script&async=true&lang=js"

import "./Search.vue?vue&type=style&index=0&id=4c526720&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c526720"]])

export default __exports__